import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles(theme => ({
  infoCardWithOverlay: {
    borderRadius: 8,
    display: 'flex',
    flexDirection: 'row',
    background: theme.palette.grey[100],
    color: theme.palette.secondary.main,
    boxShadow: theme.palette.shadow.cardBoxShadow,
    overflow: 'hidden',
    [theme.breakpoints.down('md')]: {
      flexDirection: 'column',
      height: '350px',
    },
    [theme.breakpoints.up('md')]: {
      flex: '1',
    },
    [theme.breakpoints.up('lg')]: {
      height: '250px',
      flexDirection: 'row',
    },
  },
  copyContainer: {
    zIndex: 1,
    background: theme.palette.background.paper,
    padding: `${theme.spacing(3)}px ${theme.spacing(4)}px`,
    position: 'relative',
    [theme.breakpoints.up('lg')]: {
      width: '45%',
    },
  },
  copyHeading: {
    margin: 0,
    marginBottom: theme.spacing(2),
    ...theme.typography.h5,
  },
  copyOverline: {
    ...theme.typography.overline,
    color: theme.palette.primary.dark,
    fontSize: '0.625rem',
    letterSpacing: '1.5px',
    marginBottom: 7,
  },
  showOptionsButton: {
    paddingLeft: 0,
    paddingRight: 0,
    position: 'absolute',
    bottom: 6,
    left: 32,
  },
  arrowRight: {
    marginLeft: '5px',
    fontSize: '.5rem',
    '& svg': {
      width: 17,
      verticalAlign: 'text-bottom',
    },
  },
  imgContainer: {
    position: 'relative',
    minHeight: 0,
    flex: 1,
  },
  imgOverlay: ({ isOverlayed }) => ({
    position: 'absolute',
    top: 0,
    left: 0,
    height: '100%',
    width: '100%',
    background: '#043362',
    opacity: 0.9,
    transform: isOverlayed ? 'translateX(0)' : 'translateX(-100%)',
    transition: 'all .25s ease',
    display: 'flex',
    alignItems: 'center',
    padding: '2rem 8px 2rem 3rem',
  }),
  overlayList: {
    margin: 0,
    padding: 0,
    color: 'white',
    lineHeight: '20px',
    listStyleType: 'disc',
    fontWeight: 600,
    fontSize: 14,
  },
  andMoreCopy: {
    ...theme.typography.caption,
    color: 'white',
    marginTop: 20,
  },
  img: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
  },
  a11yReader: {
    position: 'absolute',
    width: 1,
    height: 1,
    padding: 0,
    margin: -1,
    overflow: 'hidden',
    clip: 'rect(0,0,0,0)',
    border: 0,
  },
}))

export default useStyles
